import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Props {
	onSuccess?: (contentId: string) => void;
  onError?: (res: AxiosError) => void;
}

export const useDuplicateContent = ({
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onDuplicateContent,
    ...rest
	} = useMutation({
		mutationFn: async (contentId: string) => {
      return await axios.get(`/contents/${contentId}/duplicate`);
		},
		onSuccess: ({ data: { content } }) => {
      if (onSuccess)
        onSuccess(content.id);
    },
    onError
	});

	return { onDuplicateContent, ...rest };
};
